import Column from '@app/components/layout/Column'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { TabsGroup } from '@app/components/core/tabs/Tabs'
import { match } from 'ts-pattern'
import { Overview } from './Overview'
import { Thread } from '../../../../components/blocks/thread/Thread'
import { useParamState } from '@app/util/hooks/useParamState'
import { ViewInitiativeModel } from 'functions/app/initiative/view'

const tabs = {
  overview: 'overview',
  thread: 'thread',
} as const

export const TabContent = ({
  initiative,
}: {
  initiative: ViewInitiativeModel
}) => {
  const [language, _] = useLanguage()
  const translations = i18n.languages[language].app.initiativePage
  const [tab, setTab] = useParamState(tabs, tabs.overview)
  return (
    <Column alignItems="stretch" gap="2rem">
      <TabsGroup
        selectedTab={tab}
        onSelectTab={setTab}
        tabs={[
          { label: translations.overview, value: tabs.overview },
          { label: translations.thread, value: tabs.thread },
        ]}
      />
      {match(tab)
        .with(tabs.overview, () => (
          <Overview key="overview" initiative={initiative} />
        ))
        .with(tabs.thread, () =>
          initiative.thread?.id ? (
            <Thread key="thread" threadId={initiative.thread.id} />
          ) : null,
        )
        .exhaustive()}
    </Column>
  )
}
